import React from "react";
import SidebarComponent from "./sidebar";

const Sidebar = (props) => {
  const { handleLogOutScreen, open } = props;

  return (
    <>
      <SidebarComponent handleLogOutScreen={handleLogOutScreen} open={open} />
    </>
  );
};

export default Sidebar;
